/** @format */

import React, { FunctionComponent } from 'react'
import PinText from '../../components/PinText'
import styled from 'styled-components'
import { useHistory } from 'react-router'
import { _$ } from '@king-design/react'
import useGlobalData from 'src/hooks/useGlobalData'
interface contentProps {
  productName?: string
  resourceNumber?: number
  alarmingNumber?: number
  productType?: number
}

interface Props {
  color?: string
  className?: any
  text?: string
  content?: contentProps
}
const ListItem: FunctionComponent<Props> = ({ className, content }) => {
  const history = useHistory()
  const productMenu = useGlobalData('productMenu')
  return (
    <div className={className}>
      <span
        onClick={() => {
          const find = productMenu.find(menu => menu.productType === content.productType)
          find && history.push(find.link)
        }}
      >
        <i className="icon icon-kpc-eip" style={{ marginRight: '8px' }}></i>
        {_$(content?.productName)}
      </span>
      <p className="count_content">
        <span
          onClick={() => {
            history.push(`/monitor/alarmServer/alarming/home/${content.productType}`)
          }}
        >
          <PinText
            text={content?.alarmingNumber}
            className="chang_hover"
            color={content?.alarmingNumber === 0 ? '#cccccc' : '#ff4433'}
          />
        </span>
        <span style={{ marginLeft: '20px' }}></span>
        <PinText text={content?.resourceNumber} />
      </p>
    </div>
  )
}

export default styled(ListItem)`
  height: 36px;
  line-height: 36px;
  border-radius: 1px;
  margin-bottom: 0px;
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
  font-size: 12px;
  border-right: 1px solid #ccc;
  &:nth-of-type(3n) {
    border-right: none;
  }
  .count_content {
    display: inline-block;
    width: 120px;
  }
  :hover {
    background: #f5f5f9;
    cursor: pointer;
  }
  .chang_hover:hover {
    color: #0091ea;
  }
`
